import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import { DocumentLabelsSearchCard } from "./DocumentLabelsSearchCard";

export default class DocumentLabelsListEntry extends Component {
  render() {
    const {
      record,
      selectedDocuments,
      addDocumentToSelection,
      removeDocumentFromSelection,
    } = this.props;
    // Ensure we have valid data
    if (!record || !record.metadata) {
      return null;
    }

    const { metadata } = record;
    const isSelected = selectedDocuments.some(
      (doc) => doc.pid === metadata.pid
    );
    const onClickAddRemoveButton = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (isSelected) {
        removeDocumentFromSelection(metadata);
      } else {
        addDocumentToSelection(metadata);
      }
    };

    return (
      <Grid.Column className="document-labels-card">
        <DocumentLabelsSearchCard
          onClickAddRemoveButton={onClickAddRemoveButton}
          isSelected={isSelected}
          metadata={metadata}
        />
      </Grid.Column>
    );
  }
}

DocumentLabelsListEntry.propTypes = {
  record: PropTypes.object.isRequired,
  selectedDocuments: PropTypes.array.isRequired,
  addDocumentToSelection: PropTypes.func.isRequired,
  removeDocumentFromSelection: PropTypes.func.isRequired,
};
